import { openBlock as t, createElementBlock as r, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, l) {
  return t(), r("svg", o, [...l[0] || (l[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M13.314 21.749 2 10.435l19.092-7.778zm-.707-3.536L17.45 6.298 5.536 11.142l2.474 2.475 5.304-3.182-3.182 5.303zm0 0-7.071-7.07 4.596 4.595z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const i = { render: n };
export {
  i as default,
  n as render
};
